import MainContent from './PageContent';

export default MainContent;
